import React from 'react'
import { Box, SxProps } from '@mui/system'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  boxWrapper: {
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey.grey07,
    borderColor: theme.palette.grey.grey06,
    borderWidth: 1,
    borderStyle: 'solid',
    maxHeight: 'fit-content',
  },
}))

interface Props {
  children: React.ReactNode
  sx?: SxProps
}

//* Wrapper for a grey box with a border and padding. Similar to our Settingsbox component. */
const BoxWrapper: React.FC<Props> = ({ children, sx }) => {
  const { classes } = useStyles()
  return (
    <Box sx={sx} className={classes.boxWrapper}>
      {children}
    </Box>
  )
}

export default BoxWrapper
